/**
 * Define constants for mutations here so that there is a central store of what they are
 */
const path = 'widgets/announcements';
export const SET_BANNER = `${path}/SET_BANNER`;
